import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToHash = () => {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (!hash) return;

    const id = hash.slice(1);

    const timeoutId = window.setTimeout(() => {
      const element = document.getElementById(id);
      if (!element) return;

      const headerOffset = 100;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }, 150);

    return () => window.clearTimeout(timeoutId);
  }, [hash, pathname]);

  return null;
};

export default ScrollToHash;
